<template>
  <div id="members">
    <div class="main">
      <div class="search_expand_area">
        <el-button type="text" @click="toggleSearchForm">
          {{$t('cmsg.search')}}
          <i class="el-icon-arrow-right el-icon--right"></i>
        </el-button>
      </div>
      <el-form
        :inline="true"
        :model="searchForm"
        size="mini"
        class="search_form"
        status-icon
        :validate-on-rule-change="false"
        :show-message="false"
      >
        <el-form-item :label="$t('cmsg.type')">
          <el-select v-model="searchForm.factoryType" filterable>
            <el-option :label="$t('cmsg.all')" value></el-option>
            <el-option :label="$t('cmsg.hospital')" value="hospital"></el-option>
            <el-option :label="$t('cmsg.lab')" value="lab"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('cmsg.name')">
          <el-input v-model="searchForm.factoryName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('cmsg.memberName')">
          <el-input v-model="searchForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('cmsg.isAdmin')">
          <el-checkbox v-model="searchForm.isAdmin"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button
            type="default"
            @click="searchSubmit"
            :disabled="tableLoading"
            :loading="tableLoading"
            icon="el-icon-3d-search"
          >{{$t('cmsg.search')}}</el-button>
          <el-button
            type="default"
            @click="onSearchReset"
            icon="el-icon-3d-reset"
          >{{$t('cmsg.reset')}}</el-button>
          <el-button
            type="default"
            @click="factoryMemberForm.visible=true"
            v-if="perms.indexOf('dental.manage_dental_member')>-1"
            icon="el-icon-3d-new"
          >{{$t('cmsg.new')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="items" stripe style="width: 100%">
        <el-table-column :label="$t('cmsg.user')">
          <template slot-scope="scope">
            {{scope.row.NickName}}
            {{scope.row.Phone}}
            {{scope.row.Email}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('cmsg.belongs')">
          <template
            slot-scope="scope"
          >{{scope.row.FactoryName}}[{{$t(switchType(scope.row.FactoryType))}}]</template>
        </el-table-column>
        <el-table-column :label="$t('cmsg.isAdmin')">
          <template slot-scope="scope">
            <i class="el-icon el-icon-check" v-if="scope.row.IsAdmin === 'y'"/>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cmsg.action')" width="320">
          <template slot-scope="scope">
            <el-button
              type="default"
              class="case_btn"
              size="mini"
              @click="caseAction(scope.row,'resetPwd')"
            >{{$t('cmsg.resetPwd')}}</el-button>
            <el-button
              type="default"
              class="case_btn"
              @click="caseAction(scope.row,'delete')"
              size="mini"
            >{{$t('cmsg.delete')}}</el-button>
            <el-button
              type="default"
              class="case_btn"
              @click="caseAction(scope.row,'isAdmin')"
              v-if="scope.row.IsAdmin === 'n'"
              size="mini"
            >{{$t('cmsg.beAdmin')}}</el-button>
            <el-button
              type="default"
              @click="caseAction(scope.row,'notAdmin')"
              class="case_btn"
              v-if="scope.row.IsAdmin === 'y'"
              size="mini"
            >{{$t('cmsg.beMember')}}</el-button>
            <!-- <el-button type="default" class="case_btn" size="mini" @click="setAdmin(scope.row)">修改</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[5, 10, 50, 100, 200, 300, 400]"
        :page-size="pageInfo.pageSize"
        :page-count="pageInfo.pages"
        layout="prev, pager, next, total, sizes"
        :total="pageInfo.total"
      ></el-pagination>
      <el-dialog
        :title="$t('cmsg.newMember')"
        :visible.sync="factoryMemberForm.visible"
        @close="resetFactoryMemberForm"
        @open="setFactoryMemberForm"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <p v-html="$t(factoryMemberForm.description)"></p>
        <el-form
          :model="factoryMemberForm.fields"
          label-width="100px;"
          ref="factoryMemberForm"
          status-icon
          :validate-on-rule-change="false"
          :show-message="false"
        >
          <el-form-item
            :label="$t('cmsg.belongs')"
            required
            prop="factoryId"
            :error="factoryMemberForm.errors.FactoryId"
          >
            <el-select v-model="factoryMemberForm.fields.factoryId" filterable>
              <el-option :label="$t('cmsg.all')" value></el-option>
              <el-option
                v-for="im in factories"
                :key="im.KeyName"
                :label="im.KeyValue"
                :value="im.KeyName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('cmsg.nickName')"
            required
            prop="nickName"
            :error="factoryMemberForm.errors.NickName"
          >
            <el-input v-model="factoryMemberForm.fields.nickName" autocomplete="off"></el-input>
          </el-form-item>

          <el-row>
            <el-col :span="10">
              <el-form-item
                prop="phoneArea"
                 :label="$t('cmsg.mobile')"
                :error="factoryMemberForm.errors.phoneArea"
                :rules="[
        {type: 'number',message:$t('cmsg.integerRequired')}
        ]"
              >
                <el-select
                  v-model="factoryMemberForm.fields.phoneArea"
                  v-model.number="factoryMemberForm.fields.phoneArea"
                  filterable
                  :placeholder="$t('cmsg.countryCode')"
                >
                  <el-option
                    v-for="i in $countryCodes"
                    :label="i.label"
                    :value="i.value"
                    :key="i.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item
                prop="phone"
                :error="factoryMemberForm.errors.phone"
                :rules="[
        {type: 'number',message:$t('cmsg.integerRequired')}
        ]"
              >
                <el-input
                  v-model="factoryMemberForm.fields.phone"
                  v-model.number="factoryMemberForm.fields.phone"
                  :placeholder="$t('cmsg.mobile')"
                  @keyup.enter.native1="onSubmit"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            :label="$t('cmsg.email')"
            prop="email"
            :error="factoryMemberForm.errors.Email"
          >
            <el-input v-model="factoryMemberForm.fields.email" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cmsg.isAdmin')" :error="factoryMemberForm.errors.IsAdmin">
            <el-checkbox v-model="factoryMemberForm.fields.isAdmin"></el-checkbox>
          </el-form-item>
        </el-form>
        <!-- <p v-if="factoryMemberForm.err">{{factoryMemberForm.err}}</p> -->
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetFactoryMemberForm">{{$t('cmsg.close')}}</el-button>
          <el-button type="primary" @click="submitFactoryMemberForm">{{$t('cmsg.submit')}}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  components: {},
  data() {
    return {
      factoryType: {
        lab: "cmsg.lab",
        hospital: "cmsg.hospital"
      },
      searchForm: {
        name: "",
        factoryName: "",
        factoryType: "",
        isAdmin: false
      },
      factories: [],
      factoryMemberForm: {
        visible: false,
        loading: false,
        description: "cmsg.memberFormDesc",
        err: "",
        fields: {
          factoryId: "",
          nickName: "",
          phone: "",
          phoneArea: "86",
          email: "",
          isAdmin: false
        },
        errors: {
          FactoryId: null,
          NickName: null,
          Phone: null,
          PhoneArea: null,
          Email: null,
          IsAdmin: null
        }
      }
    };
  },
  methods: {
    switchCaseBtn(v) {
      switch (v) {
        case "isAdmin":
          return "cmsg.beAdmin";
        case "notAdmin":
          return "cmsg.beMember";
        case "resetPwd":
          return "cmsg.resetPwd";
        case "delete":
          return "csmg.delete";
      }
    },
    caseAction(row, btnType) {
      console.log(row);
      if (["isAdmin", "notAdmin", "delete", "resetPwd"].indexOf(btnType) > -1) {
        var hint = this.$t("cmsg.memberActionDialog", {
          action: this.$t(this.switchCaseBtn(btnType)),
          name: row.NickName
        });
        if (btnType === "resetPwd") {
          hint += this.$t("cmsg.memberActionDialogResetPwd");
        }
        this.$confirm(hint, `${this.$t(this.switchCaseBtn(btnType))}`, {
          type: "warning",
          dangerouslyUseHTMLString: true
        })
          .then(() => {
            this.$axios
              .get(`/api/u/dental/member/action/${row.Id}/${btnType}`, {
                json: true,
                validateStatus: function(status) {
                  return status >= 200 && status < 404; // default
                }
              })
              .then(res => {
                if (
                  res.status === 200 &&
                  res.data &&
                  res.data.status === "success"
                ) {
                  this.$message({
                    type: "success",
                    message: this.$t("cmsg.successAction")
                  });
                  var t = this;
                  setTimeout(function() {
                    window.location = t.$router.resolve({
                      name: "members",
                      query: t.$route.query
                    }).href;
                  }, 3000);
                } else if (
                  res.status === 200 &&
                  res.data &&
                  res.data.status !== "success"
                ) {
                  this.$message({
                    type: "error",
                    message: `${this.$t("cmsg.mting")}: ${res.data.result}.`
                  });
                } else {
                  console.log(res);
                  this.$message({
                    type: "warning",
                    message: this.$t("cmsg.mting")
                  });
                }
              })
              .catch(e => {
                console.log(e);
                this.$message({
                  type: "warning",
                  message: this.$t("cmsg.mting")
                });
              });
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    submitFactoryMemberForm() {
      console.log(this.factoryMemberForm.fields);
      this.factoryMemberForm.err = "";
      if (
        this.factoryMemberForm.fields.phone === "" &&
        this.factoryMemberForm.fields.email === ""
      ) {
        this.factoryMemberForm.err = this.$t("cmsg.mobileEmailLessOne");
        return false;
      }
      this.factoryMemberForm.fields.phone = parseInt(
        this.factoryMemberForm.fields.phone
      );
      this.factoryMemberForm.fields.phoneArea = parseInt(
        this.factoryMemberForm.fields.phoneArea
      );
      this.$refs["factoryMemberForm"].validate(valid => {
        if (valid) {
          this.factoryMemberForm.loading = true;
          this.factoryMemberForm.fields.phone = this.factoryMemberForm.fields.phone.toString();
          this.factoryMemberForm.fields.phoneArea = this.factoryMemberForm.fields.phoneArea.toString();
          var url = `/api/u/dental/member/add`;
          this.$axios
            .post(url, this.factoryMemberForm.fields, {
              json: true,
              validateStatus: function(status) {
                return status >= 200 && status < 404; // default
              }
            })
            .then(res => {
              console.log(res);
              this.factoryMemberForm.loading = false;
              if (
                res.status === 200 &&
                res.data &&
                res.data.status === "success"
              ) {
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.successAction")
                });
                this.factoryMemberForm.visible = false;
                var t = this;
                setTimeout(function() {
                  t.resetFactoryMemberForm();
                  window.location = t.$router.resolve({
                    name: "members",
                    query: t.$route.query
                  }).href;
                }, 3000);
              } else if (
                res.status === 200 &&
                res.data &&
                res.data.status !== "success"
              ) {
                this.factoryMemberForm.fields.phone = parseInt(
                  this.factoryMemberForm.fields.phone
                );
                this.factoryMemberForm.fields.phoneArea = parseInt(
                  this.factoryMemberForm.fields.phoneArea
                );
                var ermsg = {};
                try {
                ermsg = JSON.parse(res.data.result);
                }catch(e){
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.factoryMemberForm.errors[erk] = this.$t("cmsg.errField");
                });
                this.factoryMemberForm.err = res.data.result;
              } else if (
                res.status === 400 &&
                res.data &&
                res.data.status !== "success"
              ) {
                this.factoryMemberForm.fields.phone = parseInt(
                  this.factoryMemberForm.fields.phone
                );
                this.factoryMemberForm.fields.phoneArea = parseInt(
                  this.factoryMemberForm.fields.phoneArea
                );
                var ermsg = {};
                try {
                ermsg = JSON.parse(res.data.result);
                }catch(e){
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.factoryMemberForm.errors[erk] = this.$t("cmsg.errField");
                });
                this.factoryMemberForm.err = res.data.result;
              } else {
                console.log(res);
                this.$message({
                  type: "warning",
                  message: this.$t("cmsg.mting")
                });
              }
            })
            .catch(e => {
              console.log(e);
              this.factoryMemberForm.loading = false;
              this.$message({
                type: "warning",
                message: this.$t("cmsg.mting")
              });
            });
        } else {
          this.factoryMemberForm.loading = false;
          return false;
        }
      });
    },
    resetFactoryMemberForm() {
      this.factoryMemberForm = {
        visible: false,
        loading: false,
        description: "cmsg.memberFormDesc",
        err: "",
        fields: {
          factoryId: "",
          nickName: "",
          phone: "",
          phoneArea: "86",
          email: "",
          isAdmin: false
        },
        errors: {
          FactoryId: null,
          NickName: null,
          Phone: null,
          PhoneArea: null,
          Email: null,
          IsAdmin: null
        }
      };
    },
    async setFactoryMemberForm() {
      await this.$axios
        .get(`/api/u/dental/factory/options?isAdmin=true`, {
          validateStatus: function(status) {
            return status >= 200 && status < 404; // default
          }
        })
        .then(res => {
          console.log(res);
          if (
            res.status === 200 &&
            res.data &&
            res.data.result &&
            res.data.result !== null &&
            Array.isArray(res.data.result)
          ) {
            this.factories = res.data.result;
          }
        });
    },
    switchType(v) {
      return this.factoryType[v];
    },
    toggleSearchForm() {
      var el = document.querySelector(".search_form");
      var elBtn = document.querySelector(".search_expand_area .el-icon--right");
      // console.log();
      if (el.style.display === "" || el.style.display === "none") {
        el.style.display = "block";
        elBtn.classList.remove("el-icon-arrow-right");
        elBtn.classList.add("el-icon-arrow-down");
      } else {
        el.style.display = "none";
        elBtn.classList.remove("el-icon-arrow-down");
        elBtn.classList.add("el-icon-arrow-right");
      }
    },
    onSearchReset() {
      console.log(this.$route.query);
      this.searchForm = {
        name: "",
        memberName: "",
        factoryType: "",
        status: ""
      };
    },
    initSearch() {
      var queryObj = this.$route.query;
      if (queryObj["name"]) {
        this.searchForm.name = queryObj["name"];
      }
      if (queryObj["memberName"]) {
        this.searchForm.memberName = queryObj["memberName"];
      }
      if (queryObj["factoryType"]) {
        this.searchForm.factoryType = queryObj["factoryType"];
      }
      if (queryObj["status"]) {
        this.searchForm.status = queryObj["status"];
      }
    },
    searchSubmit() {
      console.log(this.searchForm);
      var queryObj = this.$route.query;
      queryObj["name"] = this.searchForm.name;
      queryObj["memberName"] = this.searchForm.memberName;
      queryObj["factoryType"] = this.searchForm.factoryType;
      queryObj["status"] = this.searchForm.status;
      queryObj["page"] = 1;
      console.log(queryObj);
      Object.keys(queryObj).map((k, i) => {
        if (
          queryObj[k] === undefined ||
          queryObj[k] === "" ||
          (k === "page" && queryObj[k] === 1)
        ) {
          delete queryObj[k];
        }
      });
      console.log(queryObj);
      window.location = this.$router.resolve({
        name: "members",
        query: queryObj
      }).href;
    },
    handleSizeChange(val) {
      console.log(val);
      var queryObj = this.$route.query;
      queryObj["pageSize"] = val;
      queryObj["page"] = 1;
      window.location = this.$router.resolve({
        name: "members",
        query: queryObj
      }).href;
      // this.$redirect({name:'cases',query: queryObj});
    },
    handleCurrentChange(val) {
      console.log(val);
      var queryObj = this.$route.query;
      queryObj["page"] = val;
      window.location = this.$router.resolve({
        name: "members",
        query: queryObj
      }).href;
      // this.$redirect({name:'cases',query: queryObj});
    }
  },
  mounted() {
    // console.log("this.perms: ", this.$store.state.perms);
    // console.log("this.$perms: ", this.$perms);
    this.initSearch();
    // this.setPerm();
    if (Cookies.get("lang") === "cn") {
      this.factoryMemberForm.fields.phoneArea = 86;
    }
    console.log("this.perms: ", this.perms);
    console.log("mounted:",pub.cdnUrl);
  },
  metaInfo() {
    return {
      title: this.$gf.sysParam(this.$gf.lang(), 'title') + "-" + this.$t("cmsg.members")
    };
  },
  async asyncData(context) {
    let pageInfo = { page: 0, pageSize: 50, pages: 0, total: 0 };
    let items = [];
    let perms = [];
    var activeIndex = "all";
    if (context.req && context.req.query && context.req.query.status) {
      activeIndex = context.req.query.status;
    }
    await context.$axios
      .get("/api/u/dental/member/list", {
        json: true,
        params: context.route.query,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res)
        // var items = [];
        if (res.data.result && Array.isArray(res.data.result)) {
          items = res.data.result;
          pageInfo = res.data.pageInfo;
        }
      })
      .catch(e => {
        console.log(e);
      });
    await context.$axios
      .get(`/api/u/settings/b/up`, {
        json: true,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res);
        if (
          res.status === 200 &&
          res.data &&
          res.data.status === "success" &&
          res.data.result !== null
        ) {
          perms = res.data.result;
        }
      })
      .catch(e => {
        console.log(e);
      });
    // console.log("perms: ",perms);
    return {
      pageInfo: pageInfo,
      items: items,
      perms: perms,
      tableLoading: false,
      activeIndex: activeIndex
    };
  }
};
</script>
<style lang="scss">
.fileDownPopover {
  .el-button {
    display: block;
    margin-left: 0px;
  }
}
#members {
  .main {
    background-color: #f7f9fb;
    padding: 15px;
    text-align: left;
    .case_nav {
      display: flex;
      overflow: auto;
    }
    .el-menu-item {
      display: inline;
      border-top: 1px solid #e6e6e6;
      border-left: 1px solid #e6e6e6;
    }
    .el-menu-item.is-active {
      background-color: #f3f3f3;
    }
    .el-menu-item:last-of-type {
      border-right: 1px solid #e6e6e6;
    }
    .hidden_delivery {
      display: none;
    }
    .large_preview {
      width: 80%;
    }
    .large_preview .el-message-box__content {
      overflow: auto;
    }
    .el-table__expanded-cell[class*="cell"] {
      padding: 0px 0px 15px 0px;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      border-top-width: 0px;
    }
    .case_btn {
      margin-right: 5px;
      margin-bottom: 5px;
      margin-left: 0px !important;
    }
    .search_expand_area {
      display: none;
    }
    .search_form {
      display: block;
    }
    @media screen and (min-width: 1020px) {
      .search_expand_area {
        display: none;
      }
      .search_form {
        display: block;
      }
    }
    .el-table__expanded-cell[class*="cell"] {
      padding-bottom: 0px !important;
    }
    @media screen and (max-width: 1020px) {
      .search_expand_area {
        display: block;
      }
      .search_form {
        display: none;
      }
      .el-menu-item [class^="el-icon-"] {
        margin-right: 0px;
      }
      .el-menu-item:not(.is-active) .dp_title {
        display: none;
        /* display: inline; */
      }
      .is-active .dp_title {
        display: inline;
      }
      .el-menu-item {
        padding: 0 0px 0 5px;
      }
      .el-pager li:not(.active) {
        display: none;
      }
    }
  }
}
</style>
